import { useAuth } from '../contexts/AuthContext';
import { BANNED_MESSAGE } from '../utils/roles';

// Amber banner for a banned user: they can still read, but every action is blocked (Phase 7, note 5).
export default function BannedBanner() {
  const { isBanned } = useAuth();
  if (!isBanned) return null;
  return (
    <div role="status" className="mx-auto mt-3 flex max-w-5xl items-center gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-900">
      <span aria-hidden="true" className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-amber-500 text-xs font-bold text-white">!</span>
      {BANNED_MESSAGE}
    </div>
  );
}
